export default {
  new: 'New',
  active: 'Active',
  inactive: 'Inactive',
  onHold: 'On-Hold',
  incomplete: 'Incomplete'
}
